import { createMainAppMicroserviceInstance } from '@servicetitan/cp-api';
import { injectable } from '@servicetitan/react-ioc';
import { EstimateStatus } from '../enums/estimate-status';
import { PortalEstimates, EstimateContainerWebModel } from './portal-estimates.api';

@injectable()
export class ProposalsApi {
    estimates: PortalEstimates;

    constructor() {
        this.estimates = new PortalEstimates(
            createMainAppMicroserviceInstance('/v1/customerportal2/estimates', '/api/cp/estimates')
        );
    }

    async getEstimateContainer(id: string): Promise<EstimateContainerWebModel | undefined> {
        return this.estimates.getEstimateContainer(id).then(({ data }) => {
            data.estimates = data.estimates.map(estimate => ({
                ...estimate,
                status: estimate.expired ? EstimateStatus.Expired : (estimate.status as number),
            }));
            return data;
        });
    }
}
